import React, { useState, useEffect } from 'react';

export const InputField = ({ item, onChange }) => {

  const [selectedValue, setSelectedValue] = useState('');
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    if (item.length > 0 && !selectedValue) {
      const firstFloor = item[0].floor;
      setSelectedValue(firstFloor);
      onChange(firstFloor);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item]);

  const handleFullscreenChange = () => {
    setIsFullscreen(!!document.fullscreenElement);
  };

  useEffect(() => {
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, []);

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedValue(value);
    onChange(value); // Chama a função onChange passando o novo valor selecionado
  };

  return (
    <div>
      
     
      {/* Condicional para esconder o select quando em tela cheia */}
      {!isFullscreen && (
        <>
         <font className="mb-4" >Selecione o setor: </font>
         <select id="inputState" className="form-group col-md-2" value={selectedValue} onChange={handleChange}>
          {item.map((setor, index) => (
            <option key={setor.idtbPractitioner} value={setor.floor}>
              {setor.floor}
            </option>
          ))}
        </select>
        </>
       
      )}
    </div>
  );
};
